var _path, _path2, _path3, _ellipse, _ellipse2, _ellipse3, _ellipse4, _ellipse5, _ellipse6, _ellipse7, _path4, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSuccess(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 97,
    height: 92,
    viewBox: "0 0 97 92",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.6947 48.2339L31.3397 66.1423C30.6365 68.4943 33.2338 70.4521 35.2918 69.1211L50.9609 58.9874L72.6339 44.9704L58.3677 34.217L44.1016 23.4636L36.6947 48.2339Z",
    fill: "url(#paint0_linear_977_1372)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.27381,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.6797 31.3703C43.1305 36.1027 48.4021 47.4027 59.2648 53.6313L73.0522 44.7426L58.6135 33.8936L44.1748 23.0447L41.6797 31.3703Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44.4914 22.9024C42.8656 25.0751 47.9669 31.6834 55.8859 37.6628C63.8048 43.6423 71.5424 46.7283 73.1685 44.5559C74.7943 42.3834 69.693 35.7751 61.774 29.7954C55.5748 25.1146 49.4866 22.2068 46.3547 22.2068C45.486 22.2068 44.8446 22.4306 44.4914 22.9024Z",
    fill: "url(#paint1_linear_977_1372)"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 73.2614,
    cy: 20.3211,
    rx: 2.71895,
    ry: 2.72346,
    fill: "url(#paint2_linear_977_1372)"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 58.2027,
    cy: 9.00842,
    rx: 3.13725,
    ry: 3.14246,
    fill: "url(#paint3_linear_977_1372)"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 74.0981,
    cy: 32.891,
    rx: 1.46405,
    ry: 1.46648,
    fill: "url(#paint4_linear_977_1372)"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 60.5034,
    cy: 21.7876,
    rx: 2.0915,
    ry: 2.09497,
    fill: "url(#paint5_linear_977_1372)"
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 79.7451,
    cy: 12.5697,
    rx: 1.2549,
    ry: 1.25698,
    fill: "url(#paint6_linear_977_1372)"
  })), _ellipse6 || (_ellipse6 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 65.7321,
    cy: 1.46648,
    rx: 1.46405,
    ry: 1.46648,
    fill: "url(#paint7_linear_977_1372)"
  })), _ellipse7 || (_ellipse7 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 60.5032,
    cy: 34.3576,
    rx: 1.2549,
    ry: 1.25698,
    fill: "url(#paint8_linear_977_1372)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.27381,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.6374 48.1729L34.1504 56.5782C36.3885 60.2485 39.7207 63.2923 41.737 64.9441L50.4641 59.2403C42.1067 54.4572 39.0854 48.1027 37.8737 43.9944L36.6374 48.1729Z",
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2,
    filter: "url(#filter0_f_977_1372)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 48.3726,
    cy: 71.6481,
    rx: 31.3725,
    ry: 3.35196,
    fill: "#4D8FF7"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_977_1372",
    x: 0.69031,
    y: 51.9865,
    width: 95.3645,
    height: 39.3232,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8.15485,
    result: "effect1_foregroundBlur_977_1372"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_977_1372",
    x1: 17.5913,
    y1: 35.1591,
    x2: 39.4555,
    y2: 65.183,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6EA6FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#126CF9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_977_1372",
    x1: 34.5515,
    y1: 28.0545,
    x2: 43.902,
    y2: 46.2123,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6EA6FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#126CF9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_977_1372",
    x1: 77.3428,
    y1: 19.9591,
    x2: 72.8781,
    y2: 15.9524,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#F2AB6A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD846"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_977_1372",
    x1: 53.0002,
    y1: 7.4608,
    x2: 55.8726,
    y2: 11.8435,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6EA6FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#126CF9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_977_1372",
    x1: 71.6702,
    y1: 32.1688,
    x2: 73.0107,
    y2: 34.2141,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6EA6FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#126CF9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_977_1372",
    x1: 57.0567,
    y1: 20.4756,
    x2: 59.6519,
    y2: 25.1754,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9F80F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.249813,
    stopColor: "#9F80F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3B1B9D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_977_1372",
    x1: 77.6771,
    y1: 11.7825,
    x2: 79.2343,
    y2: 14.6024,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9F80F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.249813,
    stopColor: "#9F80F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3B1B9D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_977_1372",
    x1: 66.6516,
    y1: 1.42464,
    x2: 65.3105,
    y2: -0.668041,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F97560"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFAE93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_977_1372",
    x1: 58.3378,
    y1: 33.6891,
    x2: 59.5156,
    y2: 35.5114,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.000983392,
    stopColor: "#D249CB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A91B97"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccess);
export default __webpack_public_path__ + "static/media/success.56728f54076484ac84d92755a756fee7.svg";
export { ForwardRef as ReactComponent };